import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { MdAdd } from 'react-icons/md';
import { format, parseISO } from 'date-fns';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function Mensagem() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);

  const getDados = useCallback(async () => {
    const responseDados = await api.get('/whatsapp');

    const data = responseDados.data.map(mes => {
      return {
        ...mes,
        dataCriacao: format(parseISO(mes.created_at), 'dd/MM/yyyy HH:mm'),
      };
    });

    setDados(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    getDados();
  }, [getDados]);

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'dataCriacao',
      label: 'Data de entrada',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  async function handlerEditar(number) {
    history.push(`/mensagem-edit/${number}`);
  }

  async function handlerStatus(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(`/whatsapp/${num}`);
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Integração excluida com sucesso');
            getDados();
          }
        });
      } else {
        const response = await api.delete(`/whatsapp/${number}`);

        if (response.data) {
          toast.success('Integração excluida com sucesso');
          getDados();
        }
      }
    } catch (error) {
      toast.error('Erro ao ativar/desativar produto');
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Listagem de integração de mensagem</h4>
      <Card>
        <Menus>
          <NewButton to="/mensagem-create">
            <MdAdd size={16} color="#FFF" />
            Novo
          </NewButton>
        </Menus>
        <Table
          title="Integrações"
          data={dados}
          columns={columns}
          ds={handlerStatus}
          ed={handlerEditar}
          messages="Você deseja excluir integração?"
          dw
          st
        />
      </Card>
    </Container>
  );
}
